import { MetricValue } from 'crux-api'

export const checkPerformanceMetric = (performance: MetricValue) => {
  return performance.percentiles.p75 < performance.histogram[0].end
}
